import { render, staticRenderFns } from "./CarouselPageButton.vue?vue&type=template&id=1c052994"
import script from "./CarouselPageButton.vue?vue&type=script&lang=ts"
export * from "./CarouselPageButton.vue?vue&type=script&lang=ts"
import style0 from "./CarouselPageButton.vue?vue&type=style&index=0&id=1c052994&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports